/**
 * Checks if given reference value is between given lower and upper limits (limit values included). If lower limit is falsy
 * limit is considered open.
 */
export const valueIsBetween = (referenceValue: any, lowerLimit: any, upperLimit: any) => {
  return (!lowerLimit || (lowerLimit && referenceValue >= lowerLimit)) && (!upperLimit || (upperLimit && referenceValue <= upperLimit))
}
